import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReduxBlockUi from 'react-block-ui/redux';
import { Row, Col, Table, Label } from 'react-bootstrap';
import Card from '../../../common/components/Card';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import FontAwesome from 'react-fontawesome';
import utils from '../../../common/services/utils';
import availabilityUtils from '../availabilityUtils';

const classTypes = {
	WEEKLY: 'weeekly',
	ONE_OFF: 'oneOff'
}

const isMobileView = window.innerWidth < 768;

class TimetableListView extends Component {

	getTimesWithTimeZone(programItem) {
		const { center, enableUserTimeZone } = this.props;

		const centerStartTimeString = moment().format('YYYY-MM-DDT') + programItem.startTime;
		const centerEndTimeString = moment().format('YYYY-MM-DDT') + programItem.endTime;
		const parentStartTimeMoment = enableUserTimeZone ? utils.convertToUserTime(centerStartTimeString, center) : moment(centerStartTimeString);
		const parentEndTimeMoment = enableUserTimeZone ? utils.convertToUserTime(centerEndTimeString, center) : moment(centerEndTimeString);

		return {
			startTime: parentStartTimeMoment,
			endTime: parentEndTimeMoment
		}
	}

	renderProgramInList(program, classType) {
		const { t, onSelectProgramItem, lessonType, enableUserTimeZone, center } = this.props;

		return <Table className='table-expanded' responsive hover>
			<thead>
				<tr>
					<th>{classType == classTypes.WEEKLY ? t('FO_Program_Weekday') : t('FO_Program_Date')}</th>
					<th>{t('FO_Program_Time')}</th>
					<th>{t('FO_Program_Grade')}</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				{program.map(item => {
					const availability = this.getAvailabilityCss(item, lessonType)
					const schedule = this.getTimesWithTimeZone(item);

					return item.lessons.length > 0 && <tr key={item.id}>
						<td className={`availability ${availability.className}`}>{(enableUserTimeZone ? utils.convertToUserTime(item.lessons[0].start, center) : moment(item.lessons[0].start)).format(classType == classTypes.WEEKLY ? 'dddd' : 'dddd L')}</td>
						<td>{schedule.startTime.format('LT')} - {schedule.endTime.format('LT')}</td>
						<td>{item.name || item.grade.name} {item.isRemote && <Label bsStyle='info'>{t('FO_Program_Online')}</Label>} {availability.isLastSpot && <Label bsStyle='danger'>{t('FO_Booking_Availability_LastSpot')}</Label>}</td>
						<td>
							<a onClick={() => onSelectProgramItem(item)} className='btn btn-primary btn-xss'>{t('FO_Program_InfoAndBooking')}  <i className='fa fa-arrow-circle-right' /></a>
						</td>
					</tr>
				})}
			</tbody>
		</Table>;
	}

	renderProgramInGrid(program, classType) {
		const { t, onSelectProgramItem, enableUserTimeZone, center, lessonType } = this.props;

		const iconStyle = {
			width: 35,
			height: 35,
			lineHeight: '35px',
			fontSize: 16,
			marginTop: '-10px'
		}

		return <Row>
			{program.map(item => {
				const availability = this.getAvailabilityCss(item, lessonType);
				const schedule = this.getTimesWithTimeZone(item);

				return item.lessons.length > 0 && <Col sm={6} key={item.id}>
					<a onClick={() => onSelectProgramItem(item)} style={{ cursor: 'pointer', textDecoration: 'none' }}>
						<Card className='availability' color={availability.className} style={{ marginBottom: 15 }}>
							<div style={{ display: 'flex', alignItems: 'center' }}>
								<div>
									<h4 style={{ marginBottom: 5 }} className='text-muted'>
										{(enableUserTimeZone ? utils.convertToUserTime(item.lessons[0].start, center) : moment(item.lessons[0].start)).format(classType == classTypes.WEEKLY ? 'dddd' : 'dddd L')} {schedule.startTime.format('LT')} - {schedule.endTime.format('LT')}
									</h4>
									<p style={{ marginTop: 10, marginBottom: 0 }}>
										<span style={{ fontSize: 16 }} className='text-normal'>{item.name || item.grade.name}</span>
										{item.isRemote && <Label bsStyle='info' style={{ marginLeft: 5 }}>{t('FO_Program_Online')}</Label>}
										{availability.isLastSpot && <Label bsStyle='danger' style={{ marginLeft: 5 }}>{t('FO_Booking_Availability_LastSpot')}</Label>}

										{/*<div className='pull-right' >*/}
										{/*	<Link to={`/public/timetable/${item.centerId}/${item.id}`} className='btn btn-primary btn-xss'>{t('FO_Program_InfoAndBooking')}  <i className='fa fa-arrow-circle-right' /></Link>*/}
										{/*</div>*/}
									</p>
								</div>
								<div style={{ marginLeft: 'auto' }}><FontAwesome name='arrow-right' className='btn-primary circle-icon' style={iconStyle} /></div>
							</div>
						</Card>
					</a>
				</Col>
			})}
		</Row>;
	}

	getAvailabilityCss(weeklyProgramItem, lessonType) {
		const { paymentTypes, center } = this.props;

		let className = 'green';
		let isLastSpot = false;

		const now = new Date();
		const upcomingLessons = weeklyProgramItem ? weeklyProgramItem.lessons.filter(x => {
			const lessonStartTime = moment(x.start).utcOffset(weeklyProgramItem.center.utcOffset, true);	// actual start time using center's timezone
			return lessonStartTime > now;
		}).sort((a, b) => a.start - b.start) : [];

		if (upcomingLessons.length == 0) {
			return { className: 'red', isLastSpot: false }
		}

		let availability = availabilityUtils.getAvailability(upcomingLessons, lessonType, paymentTypes, center);
		switch (availability) {
			case 'Yes':
				className = 'green';
				break;
			case 'No':
				className = 'red';
				break;
			case 'Limited':
				className = 'orange';
				break;
			case 'LastSpot':
				className = 'orange';
				isLastSpot = true;
				break;
		}
		return { className, isLastSpot };
	}

	renderSectionTitle(titleResourceName) {
		const { t } = this.props;
		return <div>
			<h3 style={{ float: 'left' }}>{t(titleResourceName)}</h3>
			<div className='availability-legend hidden-xs pull-right' style={{ marginTop: 15 }}>
				<span className='green' />{t('FO_Booking_Availability_Yes')}
				<span className='orange' />{t('FO_Booking_Availability_Limited')}
				<span className='red' />{t('FO_Booking_Availability_No')}
			</div>
			<div className='clearfix' />
		</div>
	}

	render() {
		const { center, weeklyProgram, t } = this.props;

		const weeklyClasses = weeklyProgram.filter(x => !x.isOneOffLesson)
			.sort((a, b) => (a.weekday - b.weekday) || (moment(a.startTime, 'HH:mm') - moment(b.startTime, 'HH:mm')));

		const now = new Date();
		const oneOffClasses = weeklyProgram.filter(x => {
			if (x.isOneOffLesson) {
				const lessonStartTime = moment(x.lessons[0].start).utcOffset(center.utcOffset, true);	// actual start time using center's timezone
				return lessonStartTime > now;	// show upcoming classes only
			}
			return false;
		})
			.sort((a, b) => moment(a.lessons[0].start) - moment(b.lessons[0].start));

		return <ReduxBlockUi block={this.props.block} unblock={this.props.unblock}>
			{weeklyClasses.length > 0 && <Row style={{ marginBottom: '15px' }}>
				<Col md={12}>
					{this.renderSectionTitle('FO_Program_WeeklyClasses')}
					<div style={{ width: '100%' }}>
						{isMobileView ? this.renderProgramInGrid(weeklyClasses, classTypes.WEEKLY) : this.renderProgramInList(weeklyClasses, classTypes.WEEKLY)}
					</div>
					<div className='clearfix' />
				</Col>
			</Row>}
			{oneOffClasses.length > 0 && <Row style={{ marginBottom: '15px' }}>
				<Col md={12}>
					{this.renderSectionTitle('FO_Program_SingleClasses')}
					<div style={{ width: '100%' }}>
						{isMobileView ? this.renderProgramInGrid(oneOffClasses, classTypes.ONE_OFF) : this.renderProgramInList(oneOffClasses, classTypes.ONE_OFF)}
					</div>
					<div className='clearfix' />
				</Col>
			</Row>}
			{weeklyClasses.length == 0 && oneOffClasses.length == 0 && <div style={{ textAlign: 'center', margin: '20px 0' }} className='text-muted'>{t('FO_Program_NoAvailableClasses')}</div>}
		</ReduxBlockUi>;
	}
}

TimetableListView.propTypes = {
	lessonType: PropTypes.oneOf(['', 'normal', 'trial', 'makeup']),
	center: PropTypes.shape({}),
	weeklyProgram: PropTypes.arrayOf(PropTypes.shape({})),
	onSelectProgramItem: PropTypes.func.isRequired
};

export default withTranslation()(TimetableListView);